/* Standing O — global + homepage behavior.
   Ported from the approved prototype (Home.dc.html). Motion mode comes from
   html[data-so-motion]: "full" | "subtle" | "off" (off is forced for
   prefers-reduced-motion before paint, in the head). */
/* Event layer — window.soTrack(name, params) → event id.
   Always publishes a Shopify custom event (so_builder_open, so_team_inquiry,
   so_add_to_cart…) that a Shopify custom pixel can forward to Meta and
   LinkedIn with Conversions API dedup. Custom events also go straight to
   fbq / lintrk when those are on the page. Standard commerce events
   (AddToCart, InitiateCheckout, Purchase) are NOT re-sent to fbq here —
   Shopify's Facebook & Instagram app already sends them, and sending
   twice would double-count. */
(function () {
  'use strict';
  var STANDARD = { PageView: 1, AddToCart: 1, InitiateCheckout: 1, Purchase: 1 };
  function snake(s) { return String(s).replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase(); }
  window.soTrack = function (name, params) {
    var p = Object.assign({}, params || {});
    var id = 'so-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    p.event_id = id;
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'so_' + snake(name), so: p }); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('so_' + snake(name), p);
      }
    } catch (e) {}
    try { if (!STANDARD[name] && typeof window.fbq === 'function') window.fbq('trackCustom', name, p, { eventID: id }); } catch (e) {}
    try {
      var li = window.StandingO && window.StandingO.linkedin;
      if (li && li[name] && typeof window.lintrk === 'function') window.lintrk('track', { conversion_id: li[name], event_id: id });
    } catch (e) {}
    return id;
  };
})();

(function () {
  'use strict';

  var cleanups = [];
  function onCleanup(fn) { cleanups.push(fn); }
  function runCleanups() { cleanups.forEach(function (f) { try { f(); } catch (e) {} }); cleanups = []; }

  function mode() {
    return document.documentElement.getAttribute('data-so-motion') || 'full';
  }

  /* ----------------------------------------------------------------------
     Header — mobile drawer + live bag count
  ---------------------------------------------------------------------- */
  function setupHeader() {
    var burger = document.querySelector('[data-so-burger]');
    var drawer = document.querySelector('[data-so-drawer]');
    if (burger && drawer) {
      var toggle = function () {
        var open = drawer.hasAttribute('data-open');
        if (open) drawer.removeAttribute('data-open'); else drawer.setAttribute('data-open', '');
        burger.setAttribute('aria-expanded', String(!open));
      };
      // bound once for the page's life — deliberately NOT in the initAll()
      // cleanup registry, which resets on every section re-init
      burger.addEventListener('click', toggle);
    }

    function setCount(n) {
      document.querySelectorAll('[data-so-cart-count]').forEach(function (el) {
        el.textContent = String(n);
        el.setAttribute('data-count', String(n));
      });
    }
    function refreshCount() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c && typeof c.item_count === 'number') setCount(c.item_count); })
        .catch(function () {});
    }
    document.addEventListener('so:cart:changed', function (e) {
      if (e.detail && typeof e.detail.item_count === 'number') setCount(e.detail.item_count);
      else refreshCount();
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
  }

  /* ----------------------------------------------------------------------
     Scroll reveals
  ---------------------------------------------------------------------- */
  function setupReveals() {
    if (mode() === 'off') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, d = el.getAttribute('data-so-delay') || '0';
        el.style.transition = 'opacity .55s var(--ease-out) ' + d + 'ms, transform .65s var(--ease-out) ' + d + 'ms';
        el.style.opacity = '1';
        el.style.transform = 'none';
        io.unobserve(el);
        // hand the element back to its stylesheet (hover lifts, etc.)
        setTimeout(function () {
          el.style.removeProperty('transition');
          el.style.removeProperty('transform');
          el.style.removeProperty('opacity');
        }, (parseInt(d, 10) || 0) + 700);
      });
    }, { threshold: 0.16 });
    document.querySelectorAll('[data-so-reveal]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) return;
      var dir = el.getAttribute('data-so-reveal');
      el.style.opacity = '0';
      el.style.transform = dir === 'left' ? 'translateX(-52px)' : dir === 'right' ? 'translateX(52px)' : 'translateY(30px)';
      io.observe(el);
    });
    onCleanup(function () { io.disconnect(); });

    // Belief curtain word rise
    var host = document.querySelector('[data-so-belief]');
    var words = host ? Array.prototype.slice.call(host.querySelectorAll('[data-so-word]')) : [];
    if (host && words.length && host.getBoundingClientRect().top > window.innerHeight * 0.9) {
      words.forEach(function (w) { w.style.transform = 'translateY(112%)'; w.style.opacity = '0'; });
      var wo = new IntersectionObserver(function (ens) {
        if (!ens.some(function (e) { return e.isIntersecting; })) return;
        words.forEach(function (w, i) {
          w.style.transition = 'transform .6s var(--ease-out) ' + (i * 60) + 'ms, opacity .4s var(--ease-out) ' + (i * 60) + 'ms';
          w.style.transform = 'none';
          w.style.opacity = '1';
        });
        wo.disconnect();
      }, { threshold: 0.35 });
      wo.observe(host);
      onCleanup(function () { wo.disconnect(); });
    }
  }

  /* ----------------------------------------------------------------------
     Looks tiles — auto-scrolling card decks
  ---------------------------------------------------------------------- */
  function setupDecks() {
    if (mode() === 'off') return;
    document.querySelectorAll('[data-so-deck]').forEach(function (track, ti) {
      var n = track.children.length;
      if (n < 3) return;
      var idx = 0, t = null;
      var step = function () {
        if (!track.children[0]) return;
        var w = track.children[0].getBoundingClientRect().width + 14;
        idx++;
        track.style.transition = 'transform .55s var(--ease-standard)';
        track.style.transform = 'translateX(' + (-idx * w) + 'px)';
        if (idx === n - 1) setTimeout(function () { track.style.transition = 'none'; track.style.transform = 'translateX(0)'; idx = 0; }, 620);
      };
      var loop = function () { step(); t = setTimeout(loop, 2600); };
      var io = new IntersectionObserver(function (ens) {
        var vis = ens.some(function (e) { return e.isIntersecting; });
        if (vis && t === null) t = setTimeout(loop, 1100 + ti * 700);
        else if (!vis && t !== null) { clearTimeout(t); t = null; }
      }, { threshold: 0.3 });
      io.observe(track.parentElement);
      onCleanup(function () { io.disconnect(); if (t !== null) clearTimeout(t); });
    });
  }

  /* ----------------------------------------------------------------------
     Hero card conveyor — new card sweeps in from off-screen right while the
     bottom card exits left of it; all cards shift one slot. No fades.
  ---------------------------------------------------------------------- */
  function setupHeroSwap() {
    if (mode() === 'off') return;
    var fan = document.querySelector('[data-so-fan]');
    if (!fan) return;
    var wraps = [];
    fan.querySelectorAll('[data-so-hero-wrap]').forEach(function (el) {
      wraps[parseInt(el.getAttribute('data-so-hero-wrap'), 10)] = el;
    });
    var queue = [];
    try { queue = JSON.parse(fan.getAttribute('data-so-conveyor') || '[]'); } catch (e) { queue = []; }
    if (!wraps[4] || wraps.length < 5 || queue.length < 1) return;
    queue.sort(function () { return Math.random() - 0.5; });
    queue.forEach(function (u) { var im = new Image(); im.src = u; });

    var shown = wraps.map(function (w) { var img = w && w.querySelector('img'); return img ? img.src : ''; });
    var R = [
      { left: '50%', top: '0%', w: '50%', rot: 8, z: 1 },
      { left: '1%', top: '7%', w: '52%', rot: -9, z: 2 },
      { left: '6%', top: '36%', w: '53%', rot: -3.5, z: 3 },
      { left: '39%', top: '42%', w: '58%', rot: 2.5, z: 4 }
    ];
    var apply = function (el, r, trans) {
      el.style.transition = trans || 'none';
      el.style.left = r.left; el.style.top = r.top; el.style.width = r.w;
      el.style.transform = 'rotate(' + r.rot + 'deg)';
      el.style.zIndex = String(r.z);
    };
    var order = [1, 0, 2, 3];
    var spare = 4;
    var spareFace = shown[4];
    var busy = false;
    var move = 'left .65s var(--ease-standard), top .65s var(--ease-standard), width .65s var(--ease-standard), transform .65s var(--ease-standard)';
    var tick = function () {
      if (busy || document.hidden || !wraps[spare] || order.some(function (i) { return !wraps[i]; })) return;
      busy = true;
      var a = order[0], b = order[1], c = order[2], d = order[3];
      var out = wraps[d], inn = wraps[spare];
      var rect = inn.parentElement.getBoundingClientRect();
      var offX = Math.round(Math.max(window.innerWidth - rect.left + 40, rect.width * 1.4)) + 'px';
      apply(inn, { left: offX, top: '-6%', w: '50%', rot: 16, z: 1 }, 'none');
      inn.style.opacity = '1';
      out.style.transition = 'left .65s cubic-bezier(.5,.1,.7,.4), top .65s cubic-bezier(.5,.1,.7,.4), transform .65s cubic-bezier(.5,.1,.7,.4)';
      apply(out, { left: offX, top: '54%', w: out.style.width, rot: 14, z: 4 }, out.style.transition);
      apply(wraps[c], R[3], move);
      apply(wraps[b], R[2], move);
      apply(wraps[a], R[1], move);
      requestAnimationFrame(function () { requestAnimationFrame(function () { apply(inn, R[0], move); }); });
      var enteredFace = spareFace;
      setTimeout(function () {
        var next = queue.shift();
        queue.push(shown[d]);
        shown[d] = next;
        spareFace = next;
        var img = out.querySelector('img');
        if (img) { img.style.animation = 'none'; img.src = next; }
        apply(out, { left: offX, top: '-6%', w: '50%', rot: 16, z: 1 }, 'none');
        busy = false;
      }, 700);
      shown[spare] = enteredFace;
      order = [spare, a, b, c];
      spare = d;
    };
    var iv = setInterval(tick, 1900);
    onCleanup(function () { clearInterval(iv); });
  }

  /* ----------------------------------------------------------------------
     Price slab — scoreboard roll 12 → +3 → 15
  ---------------------------------------------------------------------- */
  function setupScoreboard() {
    if (mode() !== 'full') return;
    var host = document.querySelector('[data-so-priceslab]');
    var roll = document.querySelector('[data-so-roll]');
    if (!roll || !host) return;
    roll.style.transform = 'translateY(0)';
    var timers = [];
    var cycle = function () {
      roll.style.transition = 'transform .5s var(--ease-out)';
      timers.push(setTimeout(function () { roll.style.transform = 'translateY(-33.334%)'; }, 1200));
      timers.push(setTimeout(function () { roll.style.transform = 'translateY(-66.667%)'; }, 2900));
      timers.push(setTimeout(function () {
        roll.style.transition = 'none';
        roll.style.transform = 'translateY(0)';
        timers.push(setTimeout(cycle, 40));
      }, 5400));
    };
    var io = new IntersectionObserver(function (ens) {
      if (ens.some(function (e) { return e.isIntersecting; })) {
        if (!timers.length) timers.push(setTimeout(cycle, 200));
      } else {
        timers.forEach(clearTimeout); timers = [];
        roll.style.transition = 'none';
        roll.style.transform = 'translateY(-66.667%)';
      }
    }, { threshold: 0.5 });
    io.observe(host);
    onCleanup(function () { io.disconnect(); timers.forEach(clearTimeout); });
  }

  /* ----------------------------------------------------------------------
     Scroll-driven: sticky buy bar, wedge (desktop + mobile), belief curtain
  ---------------------------------------------------------------------- */
  function setupScroll() {
    var clamp01 = function (x) { return Math.max(0, Math.min(1, x)); };
    var smooth = function (x) { return x * x * (3 - 2 * x); };

    var bar = document.querySelector('[data-so-stickybar]');
    var wedges = Array.prototype.slice.call(document.querySelectorAll('[data-so-wedge]'));
    var visibleWedge = function () {
      for (var i = 0; i < wedges.length; i++) { if (wedges[i].offsetHeight > 0) return wedges[i]; }
      return null;
    };

    var dWedge = document.querySelector('[data-so-wedge-cinematic]');
    var dText = document.querySelector('[data-so-wedge-text]');
    var dCard = document.querySelector('[data-so-wedge-card]');
    var dCardInner = document.querySelector('[data-so-wedge-cardinner]');
    var dSlab = document.querySelector('[data-so-wedge-slab]');
    var dL1 = document.querySelector('[data-so-wedge-l1]');
    var dL2 = document.querySelector('[data-so-wedge-l2]');

    var mWedge = document.querySelector('[data-so-wedge-m]');
    var mCard = document.querySelector('[data-so-wedge-mcard]');
    var mBubble = document.querySelector('[data-so-wedge-mbubble]');
    var mTextInner = document.querySelector('[data-so-wedge-mtext]');
    var mSlab = document.querySelector('[data-so-wedge-mslab]');
    var mL1 = document.querySelector('[data-so-wedge-ml1]');
    var mL2 = document.querySelector('[data-so-wedge-ml2]');

    var curtainWrap = document.querySelector('[data-so-belief-wrap]');
    var curtain = document.querySelector('[data-so-belief-curtain]');
    var closeInner = document.querySelector('[data-so-close-inner]');

    if (!bar && !dWedge && !mWedge && !curtainWrap) return;

    var ticking = false;
    var update = function () {
      ticking = false;
      var vh = window.innerHeight;

      if (bar) {
        var w = visibleWedge();
        var show = false;
        if (w) show = w.getBoundingClientRect().bottom < vh * 0.45;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      if (dWedge && dText && dCard && dWedge.offsetHeight > 0) {
        var r = dWedge.getBoundingClientRect();
        var total = r.height - vh;
        if (total > 60) {
          var p = clamp01(-r.top / total);
          var pA = smooth(clamp01(p / 0.42));
          var pS = clamp01((p - 0.52) / 0.26);
          dText.style.opacity = String(1 - pA);
          dText.style.transform = 'translateY(' + (-34 * pA) + 'vh)';
          dCard.style.left = (50 - 50 * pA) + '%';
          if (dCardInner) dCardInner.style.opacity = String(clamp01(1 - pS * 1.6));
          if (dSlab) dSlab.style.opacity = String(pS);
          var t1 = smooth(clamp01((p - 0.56) / 0.16));
          var t2 = smooth(clamp01((p - 0.64) / 0.18));
          if (dL1) { dL1.style.transform = 'translateY(' + (56 * (1 - t1)) + 'px)'; dL1.style.opacity = String(t1); }
          if (dL2) { dL2.style.transform = 'translateY(' + (56 * (1 - t2)) + 'px)'; dL2.style.opacity = String(t2); }
        }
      }

      if (mWedge && mCard && mWedge.offsetHeight > 0) {
        var mr = mWedge.getBoundingClientRect();
        var mtotal = mr.height - vh;
        if (mtotal > 60) {
          var mp = clamp01(-mr.top / mtotal);
          var rise = smooth(clamp01((mp - 0.14) / 0.3));
          mCard.style.transform = 'translateY(' + (100 - 100 * rise) + '%)';
          if (mBubble) {
            var ev = smooth(clamp01((mp - 0.06) / 0.14));
            mBubble.style.opacity = String(1 - ev);
            mBubble.style.transform = 'translateY(' + (-30 * ev) + 'px)';
          }
          if (mTextInner) mTextInner.style.transform = 'translateY(' + (-44 * rise) + 'px)';
          if (mSlab) mSlab.style.opacity = String(smooth(clamp01((mp - 0.54) / 0.2)));
          var mt1 = smooth(clamp01((mp - 0.6) / 0.14));
          var mt2 = smooth(clamp01((mp - 0.7) / 0.16));
          if (mL1) { mL1.style.transform = 'translateY(' + (46 * (1 - mt1)) + 'px)'; mL1.style.opacity = String(mt1); }
          if (mL2) { mL2.style.transform = 'translateY(' + (46 * (1 - mt2)) + 'px)'; mL2.style.opacity = String(mt2); }
        }
      }

      if (curtainWrap && curtain && curtainWrap.offsetHeight > 0) {
        var cr = curtainWrap.getBoundingClientRect();
        var ctotal = cr.height - vh;
        if (ctotal > 60) {
          var cp = clamp01(-cr.top / ctotal);
          var lift = smooth(clamp01((cp - 0.3) / 0.6));
          curtain.style.transform = 'translateY(' + (-104 * lift) + 'vh)';
          if (closeInner) {
            var t = smooth(clamp01((cp - 0.42) / 0.42));
            closeInner.style.opacity = String(0.2 + 0.8 * t);
            closeInner.style.transform = 'translateY(' + (46 * (1 - t)) + 'px)';
          }
        }
      }
    };
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onCleanup(function () { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); });
    update();
  }

  function initAll() {
    runCleanups();
    setupReveals();
    setupDecks();
    setupHeroSwap();
    setupScoreboard();
    setupScroll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupHeader();
    initAll();
  });

  // Theme editor: re-run motion wiring when sections re-render.
  document.addEventListener('shopify:section:load', function () { initAll(); });
  document.addEventListener('shopify:section:reorder', function () { initAll(); });
})();
